"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPixel = toPixel;
exports.isPixel = isPixel;
/**
 * Converts a number value into a <number>px value for use as CSS rules
 */
function toPixel(value) {
    return `${value}px`;
}
/** Determines if a string value is able to be interpreted as a pixel value */
function isPixel(value) {
    return value.endsWith('px');
}
//# sourceMappingURL=PixelHelper.js.map